import { HTTP_CODE_ERROR, HTTP_CODE_SUCCESS } from "enums/httpCodes";

export enum ReferredUsersResponseCode {
  SERVER_ERROR = HTTP_CODE_ERROR,
  SUCCESS = HTTP_CODE_SUCCESS,
}

export enum ReferredUsersOrder {
  ASC = "asc",
  DESC = "desc",
}
export enum ReferredUsersSortBy {
  EARNED_POINTS = "earnedPoints",
  FIRST_NAME = "firstName",
  POINTS = "points",
  REDEEM_POINTS = "redeemPoints",
}

export enum UserActivity {
  ANY = "any",
  NEW = "isNewUser",
  NOT_STREAMED = "withoutStreamingActivity",
  STREAMED = "withStreamingActivity",
}

export enum TimeRange {
  CURRENT_MONTH = "current_month",
  LAST_MONTH = "previous_month",
  LIFETIME = "lifetime",
  RECENT_7_DAYS = "recent_7_days",
  RECENT_30_DAYS = "recent_30_days",
  TODAY = "today",
  YESTERDAY = "yesterday",
}

export enum Currency {
  DIAMONDS = "DIAMONDS",
  USD = "USD",
}

export enum ReferralType {
  CREATORS = "creators",
  SUPPORTERS = "supporters",
}

export enum Filter {
  TIME_RANGE = "time_range",
  USERS = "users",
  VALUE = "value",
}

export enum AgencyLevel {
  BRONZE = "BRONZE",
  ELITE = "ELITE",
  GOLD = "GOLD",
  ROOKIE = "ROOKIE",
  ROYAL = "ROYAL",
  SILVER = "SILVER",
}

export enum PromotionMessageVariant {
  ACT_FAST = "ACT_FAST",
  HUNDRED_PERCENT = "HUNDRED_PERCENT",
  HURRY_UP = "HURRY_UP",
  ON_FIRE = "ON_FIRE",
  WELL_DONE = "WELL_DONE",
}

export enum PromotionMessageVariantV2 {
  ACHIEVED = "ACHIEVED",
  MAINTAIN = "MAINTAIN",
  ON_FIRE = "ON_FIRE",
  UPGRADE = "UPGRADE",
  WELL_DONE = "WELL_DONE",
}

export enum RegistrationType {
  CREATOR = "CREATOR",
  SUPPORTER = "SUPPORTER",
}

export enum ScreenName {
  REFERRAL_PROGRAM = "referral_program",
  REFERRAL_PROGRAM_TIER_CURRENT = "referral_program_tier_current",
  REFERRAL_PROGRAM_TIER_REACHED = "referral_program_tier_reached",
  REFERRAL_PROGRAM_TIER_UPGRADE = "referral_program_tier_upgrade",
  STATISTICS = "referral_program_statistics",
  STATISTICS_FILTERS = "referral_program_statistics_filters",
}

export enum UIActionTarget {
  COPY_INVITE_CREATORS = "copy_invite_creators",
  COPY_INVITE_SUPPORTERS = "copy_invite_supporters",
  DOWNLOAD = "download",
  FILTER = "filter",
  FILTERS = "filters",
  SEARCH = "search",
  STATISTICS = "statistics",
}
